export default __webpack_public_path__ + "static/media/Holz.4488ad9c.png";